<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="Incentive Process"
            />
        </div>

         <section id="basic-tabs-components">
        <div class="row match-height">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item active">
                    <a class="nav-link active" id="home-tab-fill" data-bs-toggle="tab" href="#incentive-process-tab" role="tab" aria-controls="incentive-process-tab" aria-selected="false">Incentive Process</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="item-tab-fill" data-bs-toggle="tab" href="#level-update-tab" role="tab" aria-controls="level-update-tab" aria-selected="false">Level Update</a>
                  </li>
                </ul>
                <hr>

                <div class="tab-content">
                  <div class="tab-pane show active" id="incentive-process-tab" role="tabpanel" aria-labelledby="incentive-process-tab-fill">
                    <div class="row">
                      <div class="col-12 col-sm-6 col-md-3 col-lg-3  mb-1">
                        <div class="mb-1">
                          <label for="colFormLabel" class="col-form-label">Month</label>
                          <vField
                              v-model="month"
                              name="month"
                              id="month"
                              type="month"
                              class="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-12 col-sm-6 col-md-1 col-lg-1 mb-1 mt-2">
                        <button
                            style="min-width: 64px;"
                            @click="onClickToGo"
                            class="btn btn-primary btn-block waves-effect waves-float waves-light"
                        > Process
                        </button>
                      </div>
                    </div>
                    <div class="card p-2" style="min-height: 200px">
                      <div class="table-responsive">
                      <table class="table table-bordered">
                        <thead>
                        <tr>
                          <th class="text-center">Type</th>
                          <th class="text-center">Month-Year</th>
                          <th class="text-center">Status</th>
                          <th class="text-center">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, i) in incentiveProcessLogList" :key="i">
                          <td class="text-center text-capitalize">{{ item.type }}</td>
                          <td class="text-center">{{ item.month_year }}</td>
                          <td class="text-center text-capitalize">{{ item.status }}</td>
                          <td v-if="!['reprocessing', 'processing'].includes(item.status)" class="text-center">
                            <button class="btn btn-primary btn-sm"
                                    title="Reprocess"
                                    @click="incentiveReProcessing(item)"
                                    style="cursor: pointer"
                            >
                              <i class="fas fa-eye"></i>
                            </button>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                      <p v-if="incentiveProcessLogList.length < 0" class="text-center mt-5">No data</p>
                    </div>
                    </div>
                    <div class="px-2 position-absolute bottom-0 mt-4">
                      <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
                    </div>

                  </div>
                  <div class="tab-pane" id="level-update-tab" role="tabpanel" aria-labelledby="level-update-tab-fill">
                    <div class="row">
                      <div class="col-12 col-sm-6 col-md-4 col-lg-3  mb-1">
                        <div class="mb-1">
                          <label for="colFormLabel" class="col-form-label">Month</label>
                          <vField
                              v-model="levelUpdateDate"
                              name="month"
                              id="month"
                              type="date"
                              class="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-12 col-md-4 mb-1 mt-2">
                        <button
                            style="min-width: 124px;"
                            @click="onClickLevelUpdate"
                            class="btn btn-primary btn-block"
                        > Level Update Process
                        </button>
                      </div>
                    </div>

                    <div class="card p-2" style="min-height: 200px">
                      <div class="table-responsive">
                        <table class="table table-bordered">
                          <thead>
                          <tr>
                            <th class="text-center">Type</th>
                            <th class="text-center">Month-Year</th>
                            <th class="text-center">Status</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(item, i) in levelUpdateLogList" :key="i">
                            <td class="text-center text-capitalize">{{ item.type }}</td>
                            <td class="text-center">{{ item.date }}</td>
                            <td class="text-center text-capitalize">{{ item.status }}</td>
                          </tr>
                          </tbody>
                        </table>
                        <p v-if="levelUpdateLogList.length < 0" class="text-center mt-5">No data</p>
                      </div>
                    </div>
                    <div class="px-2 position-absolute bottom-0 mt-4">
                      <Pagination :offset="params.offset" @onPageChange="onPageLevelChange" ref="pagination"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

        <Loader v-if="loading"/>

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import {inject, onMounted, reactive, ref} from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import handleSdm from "@/services/modules/sdm/sdm";
import { computed } from 'vue';
import Pagination from '@/components/atom/Pagination'

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const month = ref(null);
const levelUpdateDate = ref(null);
const incentiveProcessLogList = ref([]);
const levelUpdateLogList = ref([]);
let companyInfo = reactive({})
let saveNewButtonLoader = ref(false)
const tableRef = ref(null)
const token = computed(() => localStorage.getItem('token'));
const params = ref({
  offset: 20,
});

const {
  incentiveRegisterProcess,
  contactProfileLevelUpdate,
  fetchIncentiveProcessLogList,
  updateIncentiveProcessType
} = handleSdm()

const onClickToGo = () => {
  getIncentiveProcess();
}

const setPaginationData = (data) => {
  store.commit('setPaginationData', data)
};

const setLevelPaginationData = (data) => {
  store.commit('setPaginationData', data)
};

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getIncentiveProcessList();
}

const onPageLevelChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getLevelUpdateList();
}

const setLevelPagination = (data) => {
  setLevelPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const setPagination = (data) => {
  setPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}
const getIncentiveProcessList = async () => {
  let query =`?company_id=${route.params.companyId}`;
  if (route.query.page) query += '&page=' + route.query.page;
  query += '&offset=' + params.value.offset
  query += '&type=incentive-register'

  loading.value = true
  incentiveProcessLogList.value = []

  await fetchIncentiveProcessLogList(query).then(res => {
    if (!res.status){
      store.commit("resetPagination")
      return
    }

    incentiveProcessLogList.value = res.data.data;
    setPagination(res.data)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getLevelUpdateList = async () => {
  let query =`?company_id=${route.params.companyId}`;
  if (route.query.page) query += '&page=' + route.query.page;
  query += '&offset=' + params.value.offset
  query += '&type=level-update'

  loading.value = true
  levelUpdateLogList.value = []

  await fetchIncentiveProcessLogList(query).then(res => {
    if (!res.status){
      store.commit("resetPagination")
      return
    }

    levelUpdateLogList.value = res.data.data;
    setLevelPagination(res.data)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const onClickLevelUpdate = async () => {
  let query = `?company_id=${route.params.companyId}`;
  if (levelUpdateDate.value) query += '&date=' + levelUpdateDate.value;

  loading.value = true

  await contactProfileLevelUpdate(query).then(res => {
    if (!res.status){
      showError(res.message)
      return
    }
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getIncentiveProcess = async () => {
    const query = getQuery();
    loading.value = true

    await incentiveRegisterProcess(query).then(res => {
        if (!res.status){
            showError(res.message)
            return
        }
        showSuccess(res.message)
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}


const incentiveReProcessing = async (item) => {
  const confirmed = confirm("Are you sure you want to reprocess this month?");
  if (!confirmed) return;

  let query = `?company_id=${route.params.companyId}`;
  loading.value = true
  let processData = {}
  processData.status = 'reprocessing';
  processData.month = item.month_year;

  await updateIncentiveProcessType(processData, item.id, query).then(res => {
    if (!res.status){
      showError(res.message)
      return
    }
    getIncentiveProcessList()
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    if (month.value) query += '&month=' + month.value;
    return query;
}

onMounted(() => {
  Promise.all([
    getIncentiveProcessList(),
    getLevelUpdateList(),
  ])
})

</script>

<style scoped>
.head td {
  text-align: right;
}
</style>